import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { useNotify, useRefresh } from 'react-admin'
import { ConfirmDialog } from 'shared/components/Dialog/ConfirmDialog'

import { captureExceptionIfProduction } from 'helpers/utils'
import { finalizeStatement } from '../../api/jobs'
import { JobStatusDetail, StatementStatus } from '../../helpers/constants'
import { hasPermission, Permissions } from '../../Permissions'
import { GenericFormField } from '../Fields'

export const TotalCashAdvancePayments = ({ record }: any) => {
  const cashAdvancePayments = record.cash_advance_payments
  let total = 0.0
  for (let payment of cashAdvancePayments) {
    total += parseFloat(payment.amount)
    total += parseFloat(payment.fee)
  }
  return <GenericFormField label={total.toFixed(2)} />
}

export const CorrectionFinalizeButton = (props: any) => {
  const { record, permissions } = props
  const notify = useNotify()
  const refresh = useRefresh()
  const { id } = record

  if (record.status !== StatementStatus.Draft || !permissions) {
    return null
  }

  const isJobCancelled = record?.job?.status_detail === JobStatusDetail.Canceled

  return hasPermission(permissions, Permissions.IssuePaymentStatement) ? (
    <div>
      <ConfirmDialog
        handleConfirm={(): any => {
          finalizeStatement(id).then(() => {
            refresh()
            notify('Statement processed!', { type: 'success' })
          })
        }}
        handleError={(error: any) => {
          notify(`Oops, something went wrong: ${JSON.stringify(error.response.data)}`, {
            type: 'warning',
          })
          captureExceptionIfProduction(error)
        }}
        dialogContent={
          <>
            <Typography variant="h4" align="center">
              Are you sure?
            </Typography>
            <Typography align="center">
              The statement will be processed and ${record.total} will be paid out.
            </Typography>
          </>
        }
        confirmLabel="Continue"
        cancelLabel="Cancel"
      >
        <Button variant="contained" color="primary" disabled={isJobCancelled}>
          Finalize Statement
        </Button>
      </ConfirmDialog>
    </div>
  ) : null
}
